import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/plants/PlantsContent.tsx");
